import React from "react";
import ReactApexChart from "react-apexcharts";

const RevenueChart = ({ data }) => {
  if (!data) return null;

  const series = [
    {
      name: "Amount",
      data: [
        data.totalWithdrawalPendingAmount,
        data.totalWithdrawalSuccessAmount,
        data.totalRechargeAmount,
      ],
    },
  ];

  const options = {
    chart: {
      type: "line",
      height: 300,
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 900,
      },
    },
    colors: ["#6366f1"],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 6,
      hover: {
        size: 8,
      },
    },
    xaxis: {
      categories: [
        "Withdrawal Pending",
        "Withdrawal Success",
        "Recharge Amount",
      ],
    },
    dataLabels: {
      enabled: true,
    },
    grid: {
      borderColor: "#e5e7eb",
    },
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow">
      <h2 className="text-lg font-semibold mb-3">Revenue Analytics</h2>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={300}
      />
    </div>
  );
};

export default RevenueChart;